import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FooterComponent} from '../components/footer.component';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MatIconModule} from '@angular/material/icon';
import {GlobalModule} from '@app/core/global.module';

@NgModule({
    declarations: [FooterComponent],
    imports: [
        CommonModule,
        FlexLayoutModule,
        MatIconModule,
        GlobalModule
    ],
    exports: [FooterComponent]
})
export class FooterModule {
}
